import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["onClick", "onMouseMove", "onMouseOver"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { memo } from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { MenuItem, Tooltip } from '@material-ui/core';
import styled from 'styled-components';
const StyledMenuItem = styled(MenuItem).withConfig({
  displayName: "Option__StyledMenuItem",
  componentId: "sc-14r9xcp-0"
})(["text-overflow:ellipsis;display:flow-root;min-height:48px;", ""], props => props['data-focused'] ? `background-color: rgba(255, 255, 255, 0.08);` : ``);
const PecosSpace = styled.div.withConfig({
  displayName: "Option__PecosSpace",
  componentId: "sc-14r9xcp-1"
})(["padding-left:5px;"]);

var _ref = /*#__PURE__*/React.createElement(PecosSpace, {
  id: "pecos"
});

var _ref2 = /*#__PURE__*/React.createElement(CheckCircleOutlineIcon, null);

export const Option = /*#__PURE__*/memo(props => {
  var _props$data;

  const {
    innerProps: {
      onClick,
      onMouseMove,
      onMouseOver
    }
  } = props,
        innerProps = _objectWithoutProperties(props.innerProps, _excluded);

  const compact = !!props.selectProps.compactMenuItems;
  const isPhysPeco = (_props$data = props.data) === null || _props$data === void 0 ? void 0 : _props$data.pecoshospiceflag;
  const label = isPhysPeco ? `${props.label}, PECOS` : props.label;
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: label
  }, /*#__PURE__*/React.createElement(StyledMenuItem, _extends({
    component: "div",
    dense: compact,
    ref: props.innerRef,
    selected: props.isSelected,
    "data-focused": props.isFocused,
    style: _objectSpread({
      fontWeight: props.isSelected ? 600 : 400,
      fontSize: compact ? '0.9375rem' : '1rem'
    }, compact ? {
      minHeight: 36,
      paddingTop: 2,
      paddingBottom: 2
    } : {}),
    onClick: onClick
  }, innerProps), /*#__PURE__*/React.createElement(React.Fragment, null, props.children), isPhysPeco && /*#__PURE__*/React.createElement(React.Fragment, null, _ref, _ref2)));
});